import ResumeItem from "@/common/components/ResumeItem";
import { formatCurrency } from "@/common/utils/formatters";
import { checkinEntryOptions } from "@/features/maintenance/features/workflows/constants/forwardings/steps/checkinEntry/checkinEntryOptions.constant";
import EstablishmentChoiceEntryProposal from "../../../../proposal";
import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";

const DirectiveEntryExecutionEntryPending = () => {
  const { forwarding } = useForwardingTabContext<MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry>();

  return (
    <>
      <div className="flex flex-col gap-3">
        <div className="flex gap-3">
          {forwarding.directive_entry?.diagnostic?.total_value && (
            <ResumeItem
              label="Valor a receber pela manutenção"
              value={formatCurrency(Number(forwarding.directive_entry?.diagnostic?.total_value))}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}

          {forwarding.directive_entry?.diagnostic?.deadline_to_complete_in_days != null && (
            <ResumeItem
              label="Resposta esperada até"
              value={
                forwarding.directive_entry?.diagnostic?.deadline_to_complete_in_days
                  ? `${forwarding.directive_entry?.diagnostic?.deadline_to_complete_in_days} dias`
                  : '--'
              }
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}
        </div>

        <div className="flex gap-3">
          {forwarding.checkin_entry_type && (
            <ResumeItem
              label="Tipo de transporte"
              value={checkinEntryOptions[forwarding.checkin_entry_type].title}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}

          {forwarding.checkin_entry.responsible && (
            <ResumeItem
              label="Responsável por Transporte"
              value={forwarding.checkin_entry?.responsible.full_name || '--'}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}
        </div>
      </div>

      <EstablishmentChoiceEntryProposal
        proposal={forwarding.establishment_choice_entry.actual_proposal}
        showProposalDiagnostic
      />
    </>
  );
}

export default DirectiveEntryExecutionEntryPending;
